module.exports = __webpack_public_path__ + "static/static-noise-large-b0ebc3ac9010403a2d54bdbd1e2877a7.png";